<template>
  <div class="app-customer-contract-mnpout-wrapper">
    <div class="card-wrapper">
      <div class="card">
        <MnpOutInfoWrapper>
          <template v-for="slot in possibleChildSlotsFor('MnpOutInfo')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MnpOutInfoWrapper>
      </div>
    </div>
    <div class="card-wrapper">
      <div class="card list-content">
        <MnpOutDataWrapper>
          <template v-for="slot in possibleChildSlotsFor('MnpOutData')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MnpOutDataWrapper>
      </div>
    </div>
  </div>
</template>

<script>
import MnpOutInfoWrapper from './MnpOutInfoWrapper.vue'
import MnpOutDataWrapper from './MnpOutDataWrapper.vue'

export default {
  name: 'SelfServiceContractMnpOutWrapper',
  components: {
    MnpOutInfoWrapper,
    MnpOutDataWrapper
  },
  mixins: [
  ]
}
</script>
